export const CACHE_KEYS = {
    IMAGE_STUDIES: 'imageStudies',
    IMAGE_STUDY: 'imageStudy'
}